import TYPOGRAPHY from './typography';
import COLORS from './colors';
const DEFAULT_FONT_TYPE = 'body3';
const DEFAULT_FONT_COLOR = 'black';
export const textColorStylesByColorCode = {
  black: {
    color: COLORS.C_BLACK_100
  },
  black95: {
    color: COLORS.C_BLACK_95
  },
  black90: {
    color: COLORS.C_BLACK_90
  },
  black85: {
    color: COLORS.C_BLACK_85
  },
  black80: {
    color: COLORS.C_BLACK_80
  },
  black75: {
    color: COLORS.C_BLACK_75
  },
  black70: {
    color: COLORS.C_BLACK_70
  },
  black65: {
    color: COLORS.C_BLACK_65
  },
  black60: {
    color: COLORS.C_BLACK_60
  },
  black55: {
    color: COLORS.C_BLACK_55
  },
  black50: {
    color: COLORS.C_BLACK_50
  },
  black45: {
    color: COLORS.C_BLACK_45
  },
  black40: {
    color: COLORS.C_BLACK_40
  },
  black35: {
    color: COLORS.C_BLACK_35
  },
  black30: {
    color: COLORS.C_BLACK_30
  },
  black25: {
    color: COLORS.C_BLACK_25
  },
  black20: {
    color: COLORS.C_BLACK_20
  },
  black15: {
    color: COLORS.C_BLACK_15
  },
  black10: {
    color: COLORS.C_BLACK_10
  },
  black5: {
    color: COLORS.C_BLACK_5
  },
  black3: {
    color: COLORS.generateRGBA('black', 0.03)
  },
  tosca: {
    color: COLORS.C_PRIMARY_TOSCA
  },
  tosca5: {
    color: COLORS.C_SECONDARY_TOSCA_5
  },
  tosca4: {
    color: COLORS.C_SECONDARY_TOSCA_4
  },
  tosca3: {
    color: COLORS.C_SECONDARY_TOSCA_3
  },
  tosca2: {
    color: COLORS.C_SECONDARY_TOSCA_2
  },
  tosca1: {
    color: COLORS.C_SECONDARY_TOSCA_1
  },
  grey: {
    color: COLORS.C_GREY_100
  },
  white: {
    color: COLORS.C_WHITE_100
  },
  white90: {
    color: COLORS.generateRGBA('white', 0.9)
  },
  white70: {
    color: COLORS.generateRGBA('white', 0.7)
  },
  white65: {
    color: COLORS.generateRGBA('white', 0.65)
  },
  red: {
    color: COLORS.C_PRIMARY_RED
  },
  red5: {
    color: COLORS.C_SECONDARY_RED_5
  },
  red4: {
    color: COLORS.C_SECONDARY_RED_4
  },
  red3: {
    color: COLORS.C_SECONDARY_RED_3
  },
  red2: {
    color: COLORS.C_SECONDARY_RED_2
  },
  red1: {
    color: COLORS.C_SECONDARY_RED_1
  },
  green: {
    color: COLORS.C_TERTIARY_GREEN_2
  },
  green1: {
    color: COLORS.C_TERTIARY_GREEN_1
  },
  yellow: {
    color: COLORS.C_TERTIARY_YELLOW_3
  },
  yellow2: {
    color: COLORS.C_TERTIARY_YELLOW_2
  },
  yellow1: {
    color: COLORS.C_TERTIARY_YELLOW_1
  },
  brown: {
    color: COLORS.C_TERTIARY_BROWN_2
  },
  brown1: {
    color: COLORS.C_TERTIARY_BROWN_1
  },
  purple: {
    color: COLORS.C_TERTIARY_PURPLE_2
  },
  purple1: {
    color: COLORS.C_TERTIARY_PURPLE_1
  },
  teal100: {
    color: COLORS.C_TEAL_100
  },
  teal500: {
    color: COLORS.C_TEAL_500
  },
  yellow100: {
    color: COLORS.C_YELLOW_100
  },
  yellow500: {
    color: COLORS.C_YELLOW_500
  },
  red100: {
    color: COLORS.C_RED_100
  },
  red500: {
    color: COLORS.C_RED_500
  },
  red800: {
    color: COLORS.C_RED_800
  },
  pink500: {
    color: COLORS.C_PINK_500
  },
  orange500: {
    color: COLORS.C_ORANGE_500
  },
  brown300: {
    color: COLORS.C_BROWN_300
  },
  brown500: {
    color: COLORS.C_BROWN_500
  },
  green500: {
    color: COLORS.C_GREEN_500
  },
  neutral0: {
    color: COLORS.C_NEUTRAL_0
  },
  neutral10: {
    color: COLORS.C_NEUTRAL_10
  },
  neutral20: {
    color: COLORS.C_NEUTRAL_20
  },
  neutral30: {
    color: COLORS.C_NEUTRAL_30
  },
  neutral40: {
    color: COLORS.C_NEUTRAL_40
  },
  neutral50: {
    color: COLORS.C_NEUTRAL_50
  },
  neutral60: {
    color: COLORS.C_NEUTRAL_60
  },
  neutral70: {
    color: COLORS.C_NEUTRAL_70
  },
  neutral80: {
    color: COLORS.C_NEUTRAL_80
  },
  neutral90: {
    color: COLORS.C_NEUTRAL_90
  },
  neutral100: {
    color: COLORS.C_NEUTRAL_100
  },
  neutral200: {
    color: COLORS.C_NEUTRAL_200
  },
  neutral300: {
    color: COLORS.C_NEUTRAL_300
  },
  neutral400: {
    color: COLORS.C_NEUTRAL_400
  },
  neutral500: {
    color: COLORS.C_NEUTRAL_500
  },
  neutral600: {
    color: COLORS.C_NEUTRAL_600
  },
  neutral700: {
    color: COLORS.C_NEUTRAL_700
  },
  neutral800: {
    color: COLORS.C_NEUTRAL_800
  },
  neutral900: {
    color: COLORS.C_NEUTRAL_900
  }
};
export const getStyleTheme = (theme, defaultFontType = DEFAULT_FONT_TYPE, defaultFontColor = DEFAULT_FONT_COLOR) => {
  let fontType = defaultFontType;
  let fontColor = defaultFontColor;
  if (theme) {
    const themeSpliter = theme.split('-');
    [fontType, fontColor] = themeSpliter;
  }
  if (!Object.keys(TYPOGRAPHY).includes(fontType)) {
    fontType = defaultFontType;
  }
  if (!Object.keys(textColorStylesByColorCode).includes(fontColor)) {
    fontColor = defaultFontColor;
  }
  return [TYPOGRAPHY[fontType], textColorStylesByColorCode[fontColor]];
};